module.exports = __webpack_public_path__ + "img/fHYutKeC.1e7fdce4.svg";